import querySerializer from 'query-string';
import { connectRoutes } from 'redux-first-router';

import { rewritePartnerUrlType } from '../application/Signup/partnerUrl';
import signup from '../application/Signup/routes';
import userInvite from '../application/UserInvite/routes';

const routesMap = {
  ...userInvite,
  ...signup,
};

const routeOptions = {
  querySerializer,
};

rewritePartnerUrlType();

export const { reducer, middleware, enhancer } = connectRoutes(routesMap, routeOptions);
